import { fieldSalesRepInfo } from '../../utils/constant';

const PrequalificationHelpers = ({ fieldName }) => {
  if (fieldName === fieldSalesRepInfo) {
    return true;
  }
};

export default PrequalificationHelpers;
